export function autoPrint (receipt) {
  var fmt = function (v) {
    return !v && v !== 0
      ? '0.00'
      : parseFloat(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  var fmtKhr = function (v) {
    return !v && v !== 0 ? '0' : Math.round(parseFloat(v)).toLocaleString()
  }

  var disc = function (item) {
    if (!item.discount_rate || parseFloat(item.discount_rate) === 0) return '0.00%'
    return item.discount_type === '$'
      ? ('$' + fmt(item.discount_rate))
      : (fmt(item.discount_rate) + '%')
  }

  var rows = (receipt.products || []).map(function (item, idx) {
    return '<tr>' +
      '<td style="vertical-align:top;text-align:center;">' + (idx + 1) + '</td>' +
      '<td style="vertical-align:top;">' + (item.product_name_en || '') +
        (item.remarks ? '<br><span style="font-size:7px;">** ' + item.remarks + '</span>' : '') + '</td>' +
      '<td style="vertical-align:top;text-align:center;">' + item.quantity + '</td>' +
      '<td style="vertical-align:top;text-align:right;">' + fmt(item.unit_price) + '</td>' +
      '<td style="vertical-align:top;text-align:right;">' + disc(item) + '</td>' +
      '<td style="vertical-align:top;text-align:right;">' + fmt(item.total_after_discount) + '</td>' +
      '</tr>'
  }).join('')

  var meta = function (label, value) {
    return '<tr>' +
      '<td style="white-space:nowrap;">' + label + '</td>' +
      '<td style="text-align:center;width:10px;">:</td>' +
      '<td style="font-weight:700;">' + value + '</td>' +
      '</tr>'
  }

  var totalRow = function (label, value) {
    return '<tr>' +
      '<td style="text-align:right;padding-right:4px;">' + label + '</td>' +
      '<td style="text-align:center;width:8px;">:</td>' +
      '<td style="text-align:right;white-space:nowrap;font-weight:700;">' + value + '</td>' +
      '</tr>'
  }

  var billDisc = function (r) {
    if (!r.discount_rate || parseFloat(r.discount_rate) === 0) return '0.00%'
    return r.discount_type === '$'
      ? ('$ ' + fmt(r.discount_rate))
      : (fmt(r.discount_rate) + '%')
  }

  var products = receipt.products || []
  var rawTotal = products.reduce(function (s, p) {
    return s + parseFloat(p.quantity || 0) * parseFloat(p.unit_price || 0)
  }, 0)
  var itemDiscountTotal = products.reduce(function (s, p) {
    return s + (parseFloat(p.quantity || 0) * parseFloat(p.unit_price || 0) - parseFloat(p.total_after_discount || 0))
  }, 0)

  var hasCash = receipt.paid_in_riel > 0 || receipt.paid_in_usd > 0
  var showKhrGrandTotal = parseFloat(receipt.fx_rate) > 1

  var qrBox = 'position:relative;width:100%;padding-bottom:100%;overflow:hidden;background:#fff;'
  var qrImg = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;'
  var bankQrCell = receipt.bank_khqr_image
    ? '<div style="' + qrBox + '"><img src="' + receipt.bank_khqr_image + '" style="' + qrImg + '" onerror="this.parentNode.parentNode.style.display=\'none\'" /></div>' +
      '<div style="font-size:7px;margin-top:2px;text-align:center;">Bank QR</div>'
    : ''
  var telegramQrCell = receipt.telegram_qr
    ? '<div style="' + qrBox + '"><img src="' + receipt.telegram_qr + '" style="' + qrImg + '" onerror="this.parentNode.parentNode.style.display=\'none\'" /></div>' +
      '<div style="font-size:7px;margin-top:2px;text-align:center;">Telegram</div>'
    : ''
  var hasQr = !!(receipt.bank_khqr_image || receipt.telegram_qr)

  var html = '<html><head><title>Receipt</title>' +
    '<link rel="preconnect" href="https://fonts.googleapis.com">' +
    '<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Khmer:wght@400;700&display=swap" rel="stylesheet">' +
    '<style>' +
    '@page{size:80mm auto;margin:2mm 3mm;}' +
    '*{box-sizing:border-box;padding:0;margin:0;color:#000;-webkit-print-color-adjust:exact;print-color-adjust:exact;}' +
    'body{font-family:\'Noto Sans Khmer\',Arial,Helvetica,sans-serif;font-size:10px;width:100%;line-height:1.6;}' +
    '.center{text-align:center;}' +
    '.company{font-size:13px;font-weight:700;line-height:1.2;}' +
    '.sym{font-size:9px;margin:1px 0 2px;}' +
    '.dash{border:none;border-top:1px dashed #000;margin:3px 0;}' +
    'table{width:100%;border-collapse:collapse;}' +
    'th,td{font-size:10px;padding:1px 1px;word-break:break-word;}' +
    '.items-table{table-layout:fixed;}' +
    '.items-table th,.items-table td{font-size:8px;}' +
    '.items-table thead tr:first-child th{padding:1px 1px;}' +
    '.grand-inv{background:#000 !important;color:#fff !important;padding:7px 4px;font-weight:700;font-size:12px;}' +
    '.grand-inv td{color:#fff !important;background:#000 !important;}' +
    '</style></head><body>' +
    '<div class="center" style="padding:2px 0;">' +
    '<div class="company">' + (receipt.company_name_en || '') + '</div>' +
    '<div class="sym">~*~ ~*~</div>' +
    '</div>' +
    '<table style="table-layout:auto;">' +
    meta('អ្នកគិតលុយ / Cashier', receipt.cashier_name || '') +
    meta('លេខទីលាន / Field No', receipt.table_no || '') +
    meta('អត្រាប្តូរប្រាក់ / Exchange Rate', receipt.fx_rate || '') +
    (receipt.invoice_no ? meta('លេខវិក្កយបត្រ / Invoice No', receipt.invoice_no) : '') +
    (receipt.order_no ? meta('លេខការបញ្ជាទិញ / Order No', receipt.order_no) : '') +
    meta('កាលបរិច្ឆេទ / Date', receipt.stock_out_date || '') +
    '</table>' +
    '<hr class="dash">' +
    '<table class="items-table">' +
    '<thead><tr>' +
    '<th style="text-align:center;width:8%;">ល.រ<br>No</th>' +
    '<th style="text-align:left;width:40%;">បរិយាយ<br>Description</th>' +
    '<th style="text-align:center;width:8%;">ចំនួន<br>Qty</th>' +
    '<th style="text-align:right;width:14%;">តម្លៃ<br>Price</th>' +
    '<th style="text-align:right;width:12%;">បញ្ចុះ<br>Disc</th>' +
    '<th style="text-align:right;width:18%;">សរុប<br>Amount</th>' +
    '</tr></thead>' +
    '<tbody>' +
    '<tr><td colspan="6"><hr class="dash" style="margin:2px 0;"></td></tr>' +
    rows +
    '</tbody></table>' +
    '<hr class="dash">' +
    '<table style="table-layout:auto;">' +
    totalRow('សរុប / Total', '$ ' + fmt(rawTotal)) +
    totalRow('បញ្ចុះតម្លៃ(ទំនិញ) / Total Discount(items)', '$ ' + fmt(itemDiscountTotal)) +
    totalRow('សរុបបឋម / Sub Total', '$ ' + fmt(receipt.sub_total)) +
    totalRow('បញ្ចុះ(វិក្កយបត្រ) / Bill Discount', billDisc(receipt)) +
    (parseFloat(receipt.vat_amount) > 0 ? totalRow('VAT (' + receipt.vat_rate + '%)', '$ ' + fmt(receipt.vat_amount)) : '') +
    (showKhrGrandTotal ? totalRow('សរុបចុងក្រោយ / Grand Total (KHR)', '៛ ' + fmtKhr(receipt.grand_total * receipt.fx_rate)) : '') +
    '<tr class="grand-inv">' +
    '<td style="text-align:right;padding-right:4px;">សរុបចុងក្រោយ / Grand Total (USD)</td>' +
    '<td style="text-align:center;width:8px;">:</td>' +
    '<td style="text-align:right;white-space:nowrap;">$ ' + fmt(receipt.grand_total) + '</td>' +
    '</tr>' +
    (hasCash ? '<tr><td colspan="3"><hr class="dash" style="margin:2px 0;"></td></tr>' : '') +
    (receipt.paid_in_riel > 0 ? totalRow('ប្រាក់ទទួលបាន(រៀល) / Received (KHR)', '៛ ' + fmtKhr(receipt.paid_in_riel)) : '') +
    (receipt.paid_in_usd > 0 ? totalRow('ប្រាក់ទទួលបាន(ដុល្លារ) / Received (USD)', '$ ' + fmt(receipt.paid_in_usd)) : '') +
    (receipt.change_in_riel > 0 ? totalRow('អាប់(រៀល) / Change (KHR)', '៛ ' + fmtKhr(receipt.change_in_riel)) : '') +
    (receipt.change_in_usd > 0 ? totalRow('អាប់(ដុល្លារ) / Change (USD)', '$ ' + fmt(receipt.change_in_usd)) : '') +
    '</table>' +
    '<hr class="dash">' +
    '<table style="width:100%;border-collapse:collapse;margin-top:4px;">' +
    '<tr>' +
    '<td colspan="2" style="text-align:center;font-size:8px;padding:4px 2px;line-height:1.6;">សូមអរគុណ! សូមអញ្ជើញមកម្ដងទៀត<br>Thank you, Please come again</td>' +
    '</tr>' +
    (hasQr
      ? '<tr>' +
        '<td style="text-align:center;width:50%;vertical-align:top;padding:2px;">' + bankQrCell + '</td>' +
        '<td style="text-align:center;width:50%;vertical-align:top;padding:2px;">' + telegramQrCell + '</td>' +
        '</tr>'
      : '') +
    '</table>' +
    '</body></html>'

  var iframe = document.createElement('iframe')
  iframe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;border:none;'
  document.body.appendChild(iframe)
  iframe.contentDocument.write(html)
  iframe.contentDocument.close()

  var printed = false
  var doPrint = function () {
    if (printed) return
    printed = true
    iframe.contentWindow.focus()
    iframe.contentWindow.print()
    setTimeout(function () {
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe)
    }, 1000)
  }

  // Wait for all images to load before printing
  var images = Array.from(iframe.contentDocument.images)
  if (images.length === 0) {
    setTimeout(doPrint, 400)
    return
  }

  var loadedCount = 0
  var checkDone = function () {
    loadedCount++
    if (loadedCount >= images.length) doPrint()
  }

  images.forEach(function (img) {
    if (img.complete) {
      loadedCount++
    } else {
      img.addEventListener('load', checkDone)
      img.addEventListener('error', checkDone)
    }
  })

  if (loadedCount >= images.length) {
    doPrint()
  }

  // Safety fallback — print after 4s even if images stall
  setTimeout(doPrint, 4000)
}
